import { render, staticRenderFns } from "./GuideVideoBanner.vue?vue&type=template&id=724ff2f2&scoped=true"
import script from "./GuideVideoBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./GuideVideoBanner.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GuideVideoBanner.vue?vue&type=style&index=0&id=724ff2f2&prod&scoped=true&lang=css"
import style1 from "./GuideVideoBanner.vue?vue&type=style&index=1&id=724ff2f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724ff2f2",
  null
  
)

export default component.exports